import {
  FETCH_PRIVILEGIOS_REQUEST,
  FETCH_PRIVILEGIOS_SUCCESS,
  FETCH_PRIVILEGIOS_FAILURE,
  FETCH_PRIVILEGIOS_USUARIO_REQUEST,
  FETCH_PRIVILEGIOS_USUARIO_SUCCESS,
  FETCH_PRIVILEGIOS_USUARIO_FAILURE,
  CREATE_PRIVILEGIO_REQUEST,
  CREATE_PRIVILEGIO_SUCCESS,
  CREATE_PRIVILEGIO_FAILURE,
  UPDATE_PRIVILEGIO_REQUEST,
  UPDATE_PRIVILEGIO_SUCCESS,
  UPDATE_PRIVILEGIO_FAILURE,
  DELETE_PRIVILEGIO_REQUEST,
  DELETE_PRIVILEGIO_SUCCESS,
  DELETE_PRIVILEGIO_FAILURE,
  OTORGAR_PRIVILEGIOS_MASIVOS_REQUEST,
  OTORGAR_PRIVILEGIOS_MASIVOS_SUCCESS,
  OTORGAR_PRIVILEGIOS_MASIVOS_FAILURE,
  FETCH_RESUMEN_PRIVILEGIOS_REQUEST,
  FETCH_RESUMEN_PRIVILEGIOS_SUCCESS,
  FETCH_RESUMEN_PRIVILEGIOS_FAILURE,
  VERIFICAR_PRIVILEGIO_REQUEST,
  VERIFICAR_PRIVILEGIO_SUCCESS,
  VERIFICAR_PRIVILEGIO_FAILURE,
  LIMPIAR_PRIVILEGIOS_STATE
} from '../actions/types';

const initialState = {
  privilegios: [],
  privilegiosUsuario: [],
  privilegio: null,
  resumenPrivilegios: [],
  verificacionPrivilegio: null,
  total: 0,
  isLoading: false,
  error: null,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isMasivos: false,
  isVerificando: false
};

const privilegiosReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch privilegios
    case FETCH_PRIVILEGIOS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case FETCH_PRIVILEGIOS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        privilegios: action.payload.data || [],
        total: action.payload.total || 0,
        error: null
      };
    
    case FETCH_PRIVILEGIOS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        privilegios: [],
        total: 0
      };

    // Fetch privilegios de usuario
    case FETCH_PRIVILEGIOS_USUARIO_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case FETCH_PRIVILEGIOS_USUARIO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        privilegiosUsuario: action.payload || [],
        privilegios: action.payload || [], // Unifica privilegios para hooks y componentes
        error: null
      };
    
    case FETCH_PRIVILEGIOS_USUARIO_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        privilegiosUsuario: []
      };

    // Crear privilegio
    case CREATE_PRIVILEGIO_REQUEST:
      return {
        ...state,
        isCreating: true,
        error: null
      };
    
    case CREATE_PRIVILEGIO_SUCCESS:
      return {
        ...state,
        isCreating: false,
        privilegios: [action.payload, ...state.privilegios],
        privilegio: action.payload,
        error: null
      };
    
    case CREATE_PRIVILEGIO_FAILURE:
      return {
        ...state,
        isCreating: false,
        error: action.payload
      };

    // Actualizar privilegio
    case UPDATE_PRIVILEGIO_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null
      };
    
    case UPDATE_PRIVILEGIO_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        privilegios: state.privilegios.map(privilegio =>
          privilegio._id === action.payload._id ? action.payload : privilegio
        ),
        privilegio: action.payload,
        error: null
      };
    
    case UPDATE_PRIVILEGIO_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload
      };

    // Eliminar privilegio
    case DELETE_PRIVILEGIO_REQUEST:
      return {
        ...state,
        isDeleting: true,
        error: null
      };
    
    case DELETE_PRIVILEGIO_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        privilegios: state.privilegios.filter(privilegio => privilegio._id !== action.payload),
        privilegiosUsuario: state.privilegiosUsuario.filter(privilegio => privilegio._id !== action.payload),
        error: null
      };
    
    case DELETE_PRIVILEGIO_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload
      };

    // Privilegios masivos
    case OTORGAR_PRIVILEGIOS_MASIVOS_REQUEST:
      return {
        ...state,
        isMasivos: true,
        error: null
      };
    
    case OTORGAR_PRIVILEGIOS_MASIVOS_SUCCESS:
      return {
        ...state,
        isMasivos: false,
        error: null
      };
    
    case OTORGAR_PRIVILEGIOS_MASIVOS_FAILURE:
      return {
        ...state,
        isMasivos: false,
        error: action.payload
      };

    // Resumen privilegios
    case FETCH_RESUMEN_PRIVILEGIOS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case FETCH_RESUMEN_PRIVILEGIOS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        resumenPrivilegios: action.payload || [],
        error: null
      };
    
    case FETCH_RESUMEN_PRIVILEGIOS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        resumenPrivilegios: []
      };

    // Verificar privilegio
    case VERIFICAR_PRIVILEGIO_REQUEST:
      return {
        ...state,
        isVerificando: true,
        error: null
      };
    
    case VERIFICAR_PRIVILEGIO_SUCCESS:
      return {
        ...state,
        isVerificando: false,
        verificacionPrivilegio: action.payload,
        error: null
      };
    
    case VERIFICAR_PRIVILEGIO_FAILURE:
      return {
        ...state,
        isVerificando: false,
        error: action.payload,
        verificacionPrivilegio: null
      };

    // Limpiar estado
    case LIMPIAR_PRIVILEGIOS_STATE:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default privilegiosReducer;
